import { Vue, Component } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import PaymentMethodPicker from "@/components/paymentMethodPicker/paymentMethodPicker";

import { paymentMethodToSpanish } from "@/plugins/payment_helper";

@Component({
  components: { PaymentMethodPicker },
})
export default class EditSubscriptionPayment extends Vue {
  @Action action_updateSubscription;

  @Getter getCity;
  @Getter getSubscription;

  @Mutation SPINNER;

  isEditingPaymentMethod = false;
  selectedPaymentMethod = null;

  get getSubscriptionPaymentMethodToSpanish() {
    const { credit_card, payment_way } = this.getSubscription;
    if (payment_way === "credit_card") {
      return `${credit_card.credit_card_type} terminada en ${credit_card.credit_card_number}`;
    }
    return paymentMethodToSpanish(payment_way);
  }

  async updateSubscriptionPayment() {
    let payload = {
      commerceId: this.getCity.id,
      subscriptionId: this.getSubscription.id,
      subscription: {
        subscription: {
          credit_card_id: this.selectedPaymentMethod.card
            ? this.selectedPaymentMethod.card.id
            : null,
          payment_way: this.selectedPaymentMethod.type,
        },
      },
    };
    try {
      this.SPINNER(true);
      await this.action_updateSubscription(payload);
      this.SPINNER(false);
      this.isEditingPaymentMethod = false;
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Hubo un error actualizando el método de pago. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
  }
}
